import { Dialog, DialogContent, View } from "@/components/ui";
import { Package } from "@/components/shared/icons";
import { ListHeading } from "@/components/shared/list-header";
import type { RecommendedBetaService } from "../recommended-beta-card";
import { RecommendedBetaCard } from "../recommended-beta-card";
import { Typography } from "../typography";
import { useState } from "react";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";
import { app } from "@/config/env";
import { RECOMMENDED_SERVICE_IMAGES } from "@/assets/images/recommended-services";

const RecommendedServicesData = (): RecommendedBetaService[] => {
  const { distinct_id, session_id } = PosthogAnalytics.getIdentifiers();
  const landingPageDomain = app.LANDING_PAGE_DOMAIN;
  let posthogUserTrackingQuery = "";
  if (distinct_id && session_id) {
    posthogUserTrackingQuery = `?distinct_id=${distinct_id}&session_id=${session_id}`;
  }
  return [
    {
      title: "Handyman",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedHandyman,
      url: `${landingPageDomain}/services/handyman${posthogUserTrackingQuery}`,
      betaService: true,
      name: "handyman",
    },
    {
      title: "Massage",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedHomeMassage,
      url: "/service-detail/home-massage",
      betaService: false,
      name: "home-massage",
    },
    {
      title: "Pet Grooming",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedPetGrooming,
      url: "/service-detail/pet-grooming",
      name: "pet-grooming",
    },
    {
      title: "Electrician",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedElectrician,
      url: `${landingPageDomain}/services/electrician${posthogUserTrackingQuery}`,
      betaService: true,
      name: "electrician",
    },
    {
      title: "Plumbing",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedPlumbing,
      url: `${landingPageDomain}/services/plumbing${posthogUserTrackingQuery}`,
      betaService: true,
      name: "plumbing",
    },
    {
      title: "Babysitter",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedBabysitter,
      url: `${landingPageDomain}/services/babysitter${posthogUserTrackingQuery}`,
      betaService: true,
      name: "babysitter",
    },
    {
      title: "Eldercare",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedEldercare,
      url: `${landingPageDomain}/services/elderly-care${posthogUserTrackingQuery}`,
      betaService: true,
      name: "elder-care",
    },
    {
      title: "Eyelash",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedEyelash,
      url: `${landingPageDomain}/services/home-eyelash-extension${posthogUserTrackingQuery}`,
      betaService: true,
      name: "lashes",
    },
    {
      title: "Floor Polishing",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedFloorPolishing,
      url: `${landingPageDomain}/services/floor-polishing${posthogUserTrackingQuery}`,
      betaService: true,
      name: "floor-polishing",
    },
    {
      title: "Medical Escort",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedMedicalEscort,
      url: `${landingPageDomain}/services/medical-escort${posthogUserTrackingQuery}`,
      betaService: true,
      name: "medical-escort",
    },
    {
      title: "Repair & Diagnostic",
      imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedAirconRepairDiagnostic,
      url: `${landingPageDomain}/services/aircon/repair${posthogUserTrackingQuery}`,
      betaService: true,
      name: "repair-diagnostic",
    },
    // TODO: Activate when LP ready
    // {
    //   title: "Maid Agency",
    //   imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedMaidAgency,
    //   url: `${landingPageDomain}/services/maid-agency${posthogUserTrackingQuery}`,
    //   betaService: false,
    //   name: "maid-agency",
    // }
  ];
};

//Set the modalFlagProps to split the return of the A/B testing component later
export function RecommendedBetaServices() {
  const [openRecommendedServices, setOpenRecommendedServices] = useState(true);
  const handleCloseRecommendedService = () => {
    setOpenRecommendedServices(false);
  };
  if (
    PosthogAnalytics.getFeatureFlag("complete_booking_service_offer") ===
    "popup_card"
  ) {
    return (
      <Dialog
        open={openRecommendedServices}
        onOpenChange={handleCloseRecommendedService}
      >
        <DialogContent
          className="max-w-lg justify-stretch rounded-lg"
          showClose
        >
          <View className="native:p-1 flex flex-col gap-8">
            <Typography variant="body-lg">
              One Last Thing - Try Our Newest Services! 🚀
            </Typography>

            <View className="flex flex-row flex-wrap">
              {RecommendedServicesData()
                .slice(0, 3)
                .map((card, index) => (
                  <View className="w-1/3 p-1" key={`${card.title}-${index}`}>
                    <RecommendedBetaCard {...card} />
                  </View>
                ))}
            </View>
          </View>
        </DialogContent>
      </Dialog>
    );
  } else {
    return (
      <View className="flex flex-col gap-4 border-secondary-border pb-0 pt-4 web:px-4 md:px-0">
        <ListHeading title="People also book" icon={Package} />
        <View className="flex flex-row flex-wrap">
          {RecommendedServicesData().map((card, index) => (
            <View className="w-1/2 p-1" key={`${card.title}-${index}`}>
              <RecommendedBetaCard {...card} />
            </View>
          ))}
        </View>
      </View>
    );
  }
}
